import React from "react";
import { Link } from "react-router-dom";

export default function Account() {
  return (
    <div className="max-w-xl mx-auto px-6 md:px-10 py-16 md:py-24 text-center" data-testid="account-page">
      <div className="label !text-[10px]">Account</div>
      <h1 className="font-display text-4xl md:text-5xl tracking-[-0.02em] mt-4">Manage your ritual.</h1>
      <p className="mt-4 text-[15px] text-[color:var(--ink-2)]">Subscription controls, order history, and shipping preferences live here. Accounts open with your first order.</p>
      <div className="mt-10 border border-[color:var(--line)] p-8">
        <div className="label !text-[10px] mb-3">Early access</div>
        <p className="text-sm text-[color:var(--ink-2)]">Subscribe from the product page to auto-create an account after checkout.</p>
        <Link to="/preview/shop" className="inline-block mt-6 h-11 px-5 bg-[#0f0f10] text-[#faf9f5] label !tracking-[0.25em] hover:bg-[#2a2a2a] transition leading-[44px]">Shop Vitura</Link>
      </div>
    </div>
  );
}
